import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M22.98 12.25a1 1 0 0 1 1-1h29.95a1 1 0 0 1 1 1v44.01a1 1 0 1 1-2 0V13.25H24.98v43.01a1 1 0 1 1-2 0z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M.46 57.51a1 1 0 0 1 1-1h61.08a1 1 0 1 1 0 2H1.46a1 1 0 0 1-1-1M28.62 18.01a1 1 0 0 1 1-1H48.3a1 1 0 1 1 0 2H29.62a1 1 0 0 1-1-1M28.62 23.76a1 1 0 0 1 1-1H48.3a1 1 0 1 1 0 2H29.62a1 1 0 0 1-1-1M28.62 29.52a1 1 0 0 1 1-1H48.3a1 1 0 1 1 0 2H29.62a1 1 0 0 1-1-1M28.62 35.27a1 1 0 0 1 1-1H48.3a1 1 0 1 1 0 2H29.62a1 1 0 0 1-1-1M28.62 41.03a1 1 0 0 1 1-1H48.3a1 1 0 1 1 0 2H29.62a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M33.5 47.39a1 1 0 0 1 1-1h10.11a1 1 0 0 1 1 1v10.12a1 1 0 0 1-1 1H34.5a1 1 0 0 1-1-1zm2 1v8.12h8.11v-8.12z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M39.51 46.39a1 1 0 0 1 1 1v10.12a1 1 0 1 1-2 0V47.39a1 1 0 0 1 1-1M27.48 6.49a1 1 0 0 1 1-1h20.95a1 1 0 0 1 1 1v5.76a1 1 0 0 1-1 1H28.48a1 1 0 0 1-1-1zm2 1v3.76h18.95V7.49zM8.86 23.53a1 1 0 0 1 1-1h14.12a1 1 0 0 1 1 1v6.63a1 1 0 1 1-2 0v-5.63H10.86v10.74a1 1 0 1 1-2 0zM9.6 40.9a4.32 4.32 0 1 0 0 8.64 4.32 4.32 0 0 0 0-8.64m-6.32 4.32a6.32 6.32 0 1 1 12.64 0 6.32 6.32 0 0 1-12.64 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M12.11 44.46a1 1 0 0 1 .11 1.41l-1.62 1.89v9.75a1 1 0 1 1-2 0V47.39a1 1 0 0 1 .24-.65l1.86-2.17a1 1 0 0 1 1.41-.11M12.46 18.95a1 1 0 0 1 1-1h10.52a1 1 0 1 1 0 2h-9.52v3.58a1 1 0 0 1-2 0z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M18.72 10.26a1 1 0 0 1 1 1v6.75a1 1 0 1 1-2 0v-6.75a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberBuilding;
